import httpClient from "./httpClient";
import type { ApiResponse } from "../types/api";

export default class BannerApi {
  static getBanners(): Promise<ApiResponse> {
    return httpClient.get(API_URL + "/banner").then((response) => response.data);
  }

  static getBanner(): Promise<ApiResponse> {
    return httpClient.get(API_URL + "/banner/file").then((response) => response.data);
  }
}
